<div class="min-h-[80vh] flex items-center justify-center px-4 py-16 bg-station-cream">
  <div class="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
    <h1 class="text-3xl font-bold mb-2 text-flap-black">Reset your password</h1>

    @if (invalidLink) {
      <p class="text-rail-gray mb-8">
        This reset link is invalid or has expired. Reset links are only valid for one hour.
      </p>
      <p class="text-center text-sm text-rail-gray">
        <a routerLink="/forgot-password" class="text-signal-orange font-semibold hover:underline">Request a new link</a>
      </p>
    } @else {
      <p class="text-rail-gray mb-8">Choose a new password for your account.</p>

      <form (ngSubmit)="submit()" class="space-y-5">
        <div>
          <label for="new-password" class="block text-sm font-semibold text-flap-black mb-1">New password</label>
          <input
            id="new-password"
            type="password"
            autocomplete="new-password"
            required
            minlength="8"
            [ngModel]="newPassword()"
            (ngModelChange)="newPassword.set($event)"
            name="newPassword"
            class="w-full px-4 py-3 rounded-lg border-2 border-border-subtle focus:border-signal-orange outline-none transition-colors"
          />
        </div>

        <div>
          <label for="confirm-password" class="block text-sm font-semibold text-flap-black mb-1">Verify new password</label>
          <input
            id="confirm-password"
            type="password"
            autocomplete="new-password"
            required
            [ngModel]="confirmPassword()"
            (ngModelChange)="confirmPassword.set($event)"
            name="confirmPassword"
            class="w-full px-4 py-3 rounded-lg border-2 border-border-subtle focus:border-signal-orange outline-none transition-colors"
          />
        </div>

        @if (error(); as err) {
          <p class="text-sm text-signal-orange">{{ err }}</p>
        }

        <button
          type="submit"
          [disabled]="submitting()"
          class="w-full px-6 py-3 bg-signal-orange text-white rounded-lg font-semibold hover:bg-signal-orange/90 transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
        >
          {{ submitting() ? 'Resetting…' : 'Reset password' }}
        </button>
      </form>
    }
  </div>
</div>